// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import React from 'react';
import { useTranslation } from 'react-i18next';

import ServiceRequestAndDeviceLookup from './../../components/ServiceRequestAndDeviceLookup/.';
import Styles from './dashboard.module.scss';

export default function DashboardContent() {
    const { t } = useTranslation();
    return (
        <div className={Styles.dashboardContent}>
            <div className={Styles.middleSection}>
                <div className={Styles.firstSection}>
                    <h1 className={Styles.user}>{t('hello_user')}</h1>
                    <div className={Styles.desc}>{t('landing_page_message')} </div>
                </div>
                <div className={Styles.secondSection}>
                    <h2 className={Styles.title}>{t('what_do_you_want_to_work_on')}</h2>
                    <ServiceRequestAndDeviceLookup />
                </div>
            </div>
        </div>
    );
}
